import * as React from 'react';
import * as styles from './styles.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { ITextFieldStyles } from '@fluentui/react/lib/TextField';
import { taskTitlePlaceholder } from '../taskStrings.locstring.json';
import type { TaskViewTitleProps } from '../schema';
import useTaskViewTitleState from '../hooks/useTaskViewTitleState';
import loc from 'owa-localize';
import { TextFieldWithHiddenLabel } from 'owa-timestream-asset-sdk';

const textFieldStyles: Partial<ITextFieldStyles> = {
    root: styles.taskTitle,
    field: styles.taskTitleInput,
    fieldGroup: styles.taskFieldGroup,
};

const textFieldCompleteStyles: Partial<ITextFieldStyles> = {
    ...textFieldStyles,
    field: classNames(styles.taskTitleInput, styles.taskComplete),
};

export default observer(function TaskViewTitle(props: TaskViewTitleProps) {
    const { isComplete, textFieldProps } = useTaskViewTitleState(props);

    return (
        <TextFieldWithHiddenLabel
            {...textFieldProps}
            placeholder={loc(taskTitlePlaceholder)}
            borderless={true}
            multiline={true}
            autoAdjustHeight={true}
            resizable={false}
            styles={isComplete ? textFieldCompleteStyles : textFieldStyles}
        />
    );
});
